module.exports = __webpack_public_path__ + "img/loginVerify.b2de0a95.jpg";